import gql from 'graphql-tag';

export default gql`
  mutation ArchiveContactUs($id: ID!) {
    archiveContactUs(id: $id) {
      id
    }
  }
`; 


// WEBPACK FOOTER //
// ./src/graphql/mutations/ArchiveContactUs.ts